<template>
	<ShareButton
		:classes="{'whatsapp-button': true}"
		:link="link"
	>
		<template #icon>
			<Icon
				class="icon-social"
				icon-name="logo-whatsapp"
				size="lg"
			/>
		</template>
	</ShareButton>
</template>

<script>
import ShareButton from './ShareButton';
import Icon from '@components/Icon';

export default {
	name:       'WhatsAppShareButton',
	components: { ShareButton, Icon },
	props:      {
		link: {
			type:     String,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

$green-whatsapp: #25D366;

.whatsapp-button::v-deep {
	color: var(--color-soft-white);
	background-color: $green-whatsapp;
	border-color: $green-whatsapp;
}

</style>
